import React from "react"
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl"
import { Link } from "react-router-dom"
import GlobalHelper from "../../common/GlobalHelper"
import Panel from "../../common/container/Panel"
import FingerprintDetails from "../../fingerprint/details.component.jsx"
import CreditMemoModalLink from "../../invoice/creditmemomodallink.component"
import PaymentTypeIcon from "../../invoice/paymenttypeicon.component"
import { PAYMENT_TYPE } from "../../state/helpers/Payment"
import { CreditMemoElastic } from "../../state/listing/credit-memo/models/creditMemoElastic"
import { PaymentElastic } from "../../state/listing/payment/models"
import Payment from "../../state/payment/Payment"
import PaymentExternalDetails from "../externaldetails.component"
import EditPaymentContactModal from "../modal/EditPaymentContactModal"
import PaymentSource from "../source.component"
import PaymentStatus from "../status.component"


type OwnProps = {
    payment: Payment,
    creditMemo : CreditMemoElastic,
    originalPayment : Payment
    applicationPayments : PaymentElastic[]
    onChangeContact: (contactId: string) => void
}

const PaymentDetailsInfo = (props: OwnProps) => {

    const applicationPaymentsLink = props.applicationPayments? props.applicationPayments.map((applicationPayment, index) => (
        (
            <div  key={index}>
                <Link to={"/payments/" + applicationPayment.id + "/edit"}>
                    {applicationPayment.identifier}
                </Link>
            </div>
        )
    )) : []

    const getFormattedMessagePerPaymentType = (paymentType : PAYMENT_TYPE) =>
    {
        switch (paymentType) {
        case PAYMENT_TYPE.CHECK:
            return <FormattedMessage id="invoice.receive_payment.check_label" />
        case PAYMENT_TYPE.CASH:
            return <FormattedMessage id="invoice.receive_payment.cash_label" />
        case PAYMENT_TYPE.CREDIT_CARD:
            return <FormattedMessage id="invoice.receive_payment.credit_card_label" />
        case PAYMENT_TYPE.ON_ACCOUNT:
            return <FormattedMessage id="invoice.refund_method.refund_credit.name" />
        case PAYMENT_TYPE.CREDIT:
            return <FormattedMessage id="invoice.receive_payment.generic_credit_label" />
        case PAYMENT_TYPE.BANK_TRANSFER:
            return <FormattedMessage id="invoice.receive_payment.bank_transfer_label" />
        case PAYMENT_TYPE.EXTERNAL:
            return <FormattedMessage id="payment_details.external_label" defaultMessage="External"/>
        case PAYMENT_TYPE.GIFT_CARD:
            return <FormattedMessage id="invoice.receive_payment.gift_card_label" />

        default: return <span>{paymentType}</span>
        }
    }



    const renderFieldColumn = (colClass, labelFormattedMessage, mainValue, secondaryValue?) => {
        return <div className={"position-relative mt-2 px-1 text-break " + colClass}>
            <div className={"py-1 px-2 h-100 inline-input"}>
                {labelFormattedMessage ?
                    <div>
                        <label className="col-form-label custom-form-label project-details-label pt-0">
                            {labelFormattedMessage}
                        </label>
                    </div> : ""
                }
                <div>
                    {mainValue}
                    {secondaryValue}
                </div>
            </div>
        </div>
    }

    return (
        <>
            <div className={"row ui-module"}>
                <div className={"col-lg-6 col-md-12 pl-md-3 pr-md-0 pr-lg-3 " +
                (["lg", "xl"].includes(GlobalHelper.getResponsiveBreakpoint()) ? "border-right" : "")} >
                    <div className={"row mb-md-3"}>
                        <div className="col-12 pl-0 pr-md-0 pl-lg-1">
                            <h3 className={"m-0 d-flex align-items-center"}>
                                < FormattedMessage
                                    id="payment.analytics.title_label"
                                    defaultMessage="Payment {paymentId}"
                                    values={{
                                        paymentId : props.payment.getIdentifier()
                                    }}
                                />
                                <h6 className="ml-2 d-inline mb-0">
                                    <PaymentStatus value={props.payment.getStatus()} /></h6>
                            </h3>
                        </div>
                        {!GlobalHelper.isEnvProduction() && props.payment.getContact() && renderFieldColumn(
                            "col-lg-3",
                            <FormattedMessage
                                id="payment-details.contact"
                                defaultMessage="Contact"
                            />,
                            <EditPaymentContactModal payment={props.payment} onChange={props.onChangeContact} />,
                        )}
                        {renderFieldColumn("col-lg-3", <FormattedMessage
                            id="invoice.analytics.events.payment_received.source_label"
                        />, <PaymentSource value={props.payment.getSource()} ></PaymentSource>
                        )}
                        {renderFieldColumn("col-lg-3", <FormattedMessage
                            id="common.rich_text.merge_fields.captured_at_label"
                        />, <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={props.payment.getCapturedAt()}/>

                        )}
                        {props.payment.getSucceededAt() && renderFieldColumn("col-lg-3", <FormattedMessage
                            id="payment.payment_details.succeeded_at"
                            defaultMessage="Succeeded At"
                        />, <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={props.payment.getSucceededAt()}/>
                        )}
                        {renderFieldColumn("col-lg-3", <FormattedMessage
                            id="invoice.credit_memo_modal.notes_label"
                        />, props.payment.getNote()
                        )}
                        { props.creditMemo  && renderFieldColumn("col-lg-3", <FormattedMessage
                            id="payment.payment_details.credit_memo_applied"
                            defaultMessage="Credit Memo applied"
                        />, <CreditMemoModalLink
                            creditMemoId={props.creditMemo.id}
                            creditMemoIdentifier={props.creditMemo.identifier}
                            contactId={props.creditMemo.contactId} />
                        )}
                        { props.originalPayment instanceof Payment && renderFieldColumn("col-lg-3", <FormattedMessage
                            id="payment.analytics.original_payment_label"
                            defaultMessage="Original Payment"
                        />, <Link to={"/payments/" + props.originalPayment.getId() + "/edit"}>
                            {props.originalPayment.getIdentifier()}
                        </Link>
                        )}
                        {renderFieldColumn("col-lg-3", <FormattedMessage
                            id="invoice.receive_payment.payment_type_label"
                        />,<PaymentTypeIcon value={props.payment.getType()} icon={props.payment.getPaymentTypeIcon()} className={"mr-1"}/>
                        , getFormattedMessagePerPaymentType(props.payment.getType() as PAYMENT_TYPE))}
                        { applicationPaymentsLink.length > 0 && renderFieldColumn("col-lg-3", <FormattedMessage
                            id="payment.analytics.credit_memo_application_payment_label"
                            defaultMessage="Credit Memo Application Payment"
                        />,
                        <div>{applicationPaymentsLink}</div>
                        )}
                    </div>
                    <div className={"row mb-md-3 flex-grow-1"}>
                        <div className="col-lg-3 pl-0 pr-md-0 pl-lg-1">
                            <Panel
                                messageId="invoice.analytics.total_amount_label"
                                backgroundColor="bg-custom-primary"
                                value={props.payment.getAmount()}
                                currency={props.payment.getCurrency()}
                                type="moneyTotal"/>

                        </div>
                        {
                            props.payment.getTotalRefundedAmount() < 0 && <div className="col-3 pl-0 pr-md-0 pl-lg-1">
                                <Panel
                                    messageId="invoice.listing.headers.refunded"
                                    backgroundColor="bg-custom-yellow"
                                    value={props.payment.getTotalRefundedAmount()}
                                    currency={props.payment.getCurrency()}
                                    type="moneyTotal"/>

                            </div>
                        }
                    </div>
                </div>
                <div className={"col-lg-6 col-md-12 pl-md-3 pr-md-0 pr-lg-3 " } >
                    <div className={"col-12g"} >
                        <div className={"col-16"}>
                            <FingerprintDetails fingerprintId={props.payment.getFingerprintId()} style={"panel"} />
                        </div>
                    </div>
                    <div className={"col-12g mt-2"} >
                        <PaymentExternalDetails value={props.payment.getPayment()} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default injectIntl(PaymentDetailsInfo)


// WEBPACK FOOTER //
// ./src/payment/components/PaymentDetailsInfo.tsx